/** Query key for pre-selected party on `/account/customerinfo` (must match links from managed users etc.). */
export const CUSTOMER_INFO_USER_SEARCH_PARAM = "user";
